import React from 'react';
import { t } from '@lingui/macro';
import PropTypes from 'prop-types';
import {
  ClassIcon,
  GroupIcon,
  StudentIcon
} from '../../../../../../helpers/icon-dictionary';
import Container from './doughnut-legend.styled';
import SvgIcon from '../../../../../svg-icon/svg-icon';

const DoughnutsLegend = ({ i18n, type, studentName, truncatedName }) => {
  const ClassLegend = () => (
    <div className="legend-shell">
      <div className="class color-indi" />
      <SvgIcon icon={ClassIcon} />
      <p className="text-indi" data-testid="group-text">
        {i18n._(t('doughnutClass')`Class`)}
      </p>
    </div>
  );

  const GroupLegend = () => (
    <div className="legend-shell">
      <div className="group color-indi" />
      <SvgIcon icon={GroupIcon} />
      <p className="text-indi" data-testid="class-text">
        {i18n._(t('doughnutGroup')`Group`)}
      </p>
    </div>
  );

  const StudentLegend = () => (
    <div className="legend-shell">
      <div className="student color-indi" />
      <SvgIcon icon={StudentIcon} />
      <p title={studentName} className="text-indi" data-testid="student-name">
        {truncatedName}
      </p>
    </div>
  );

  const items = [
    <ClassLegend />,
    <Container>
      <ClassLegend />
      <GroupLegend />
    </Container>,
    <>
      <StudentLegend />
      <Container>
        <GroupLegend />
        <ClassLegend />
      </Container>
    </>
  ];
  return items[type];
};

DoughnutsLegend.propTypes = {
  i18n: PropTypes.object,
  type: PropTypes.number,
  studentName: PropTypes.string,
  truncatedName: PropTypes.string
};

export default DoughnutsLegend;



// WEBPACK FOOTER //
// ./components/student-list/student-modal/student-result/doughnut-chart/doughnut-legend/doughnut-legend.js